import { ApiRequest, postItem } from "utils/ApiUtils";
import buildQuery from 'odata-query';
import ODataUtil from 'utils/ODataUtil';
import { Project } from 'classes';

const projects_endpoint = "/Project";


async function getProjects(page, per_page, orderByInfo, orderByDirection, search, filters) {
  const model = Project;
  const endpoint = projects_endpoint;
  const data = await ODataUtil.gridQuery(page, per_page, orderByInfo, orderByDirection, search, filters, { model, endpoint });
  return data;
}

async function getProject(projectId) {
  const params = buildQuery({ filter: { ProjectId: { eq: { type: 'guid', value: projectId } } } });
  const data = await ApiRequest(projects_endpoint, params);
  return new Project(data.value[0]);
}

async function addProject(formValues) {
  //projectName, projNumber,taskNumber,projectTypeId,projectStatusId,priorityId,description
  const resourcePath = `${projects_endpoint}/Add`
  const params = ``
  const result = await postItem(resourcePath, params, formValues)
  // console.log(result)
  return result
}

async function updateProject(projectId) {

  return {}
}

async function exportProjectInspections(projectId) {
  const endpoint = `/Project/ExportProjectInspections`;
  const urlParams = `?projectId=${projectId}`;

  const blob = await ApiRequest(endpoint, urlParams, { method: "GET" }, {}, true);

  if (blob instanceof Blob) {
    return new Promise((resolve) => {
      const blobUrl = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = blobUrl;
      link.setAttribute('download', `ProjectInspections_${projectId}.xlsx`);
      document.body.appendChild(link);

      // resolve as soon as download is triggered
      link.onclick = () => {
        resolve();
      };

      link.click();
      link.remove();
    });
  } else {
    throw new Error("Export failed");
  }
}






export { Project, getProjects, getProject, updateProject, addProject, exportProjectInspections };